export interface CategoryItem {
  id: string;
  nameKey: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: CategoryItem[] = [
  {
    id: 'shoes',
    nameKey: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20white%20leather%20sneakers%20displayed%20on%20a%20simple%20warm%20cream%20studio%20background%20with%20soft%20natural%20window%20light%2C%20clean%20minimal%20ecommerce%20product%20photography%2C%20warm%20neutral%20beige%20tones%2C%20editorial%20composition%20with%20gentle%20shadows&width=600&height=400&seq=cat-shoes&orientation=landscape',
  },
  {
    id: 'hoodies',
    nameKey: 'hoodies',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20cozy%20hoodies%20and%20sweaters%20in%20muted%20grey%20and%20beige%20tones%20stacked%20on%20a%20warm%20neutral%20studio%20background%2C%20soft%20diffused%20lighting%2C%20minimal%20streetwear%20product%20photography%2C%20clean%20aesthetic&width=600&height=400&seq=cat-hoodies&orientation=landscape',
  },
  {
    id: 'tshirts',
    nameKey: 'tshirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20folded%20cotton%20t-shirts%20in%20soft%20pastel%20and%20earth%20tones%20on%20a%20light%20warm%20background%2C%20soft%20natural%20light%2C%20minimal%20fashion%20product%20photography%2C%20clean%20flat%20lay%20composition&width=600&height=400&seq=cat-tshirts&orientation=landscape',
  },
  {
    id: 'jackets',
    nameKey: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20beige%20bomber%20jacket%20hanging%20on%20a%20wooden%20hanger%20against%20a%20warm%20cream%20wall%2C%20soft%20studio%20lighting%2C%20minimal%20fashion%20product%20photography%2C%20warm%20neutral%20tones%2C%20premium%20editorial%20aesthetic&width=600&height=400&seq=cat-jackets&orientation=landscape',
  },
  {
    id: 'pants',
    nameKey: 'pants',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-user-line',
    image: 'https://readdy.ai/api/search-image?query=Folded%20denim%20jeans%20and%20casual%20chino%20pants%20arranged%20on%20a%20light%20warm%20neutral%20background%2C%20soft%20natural%20light%2C%20minimal%20product%20photography%2C%20clean%20organized%20composition%20with%20soft%20shadows&width=600&height=400&seq=cat-pants&orientation=landscape',
  },
  {
    id: 'headwear',
    nameKey: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-star-line',
    image: 'https://readdy.ai/api/search-image?query=Collection%20of%20baseball%20caps%20and%20knit%20beanies%20in%20earth%20tones%20arranged%20on%20a%20warm%20neutral%20studio%20background%2C%20soft%20diffused%20lighting%2C%20minimal%20product%20photography%2C%20clean%20tidy%20composition&width=600&height=400&seq=cat-headwear&orientation=landscape',
  },
  {
    id: 'sets',
    nameKey: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    image: 'https://readdy.ai/api/search-image?query=Matching%20two%20piece%20streetwear%20outfit%20set%20displayed%20on%20a%20mannequin%20against%20a%20warm%20cream%20studio%20backdrop%2C%20soft%20lighting%2C%20minimal%20fashion%20photography%2C%20coordinated%20modern%20aesthetic&width=600&height=400&seq=cat-sets&orientation=landscape',
  },
  {
    id: 'underwear',
    nameKey: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20cotton%20underwear%20basics%20in%20neutral%20tones%20on%20a%20soft%20warm%20studio%20background%2C%20gentle%20diffused%20lighting%2C%20minimal%20product%20photography%2C%20clean%20and%20fresh%20composition&width=600&height=400&seq=cat-underwear&orientation=landscape',
  },
  {
    id: 'jersey',
    nameKey: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Athletic%20sports%20jersey%20hanging%20against%20a%20warm%20neutral%20studio%20backdrop%2C%20soft%20diffused%20lighting%2C%20minimal%20product%20photography%2C%20clean%20sportswear%20aesthetic%20with%20subtle%20texture&width=600&height=400&seq=cat-jersey&orientation=landscape',
  },
  {
    id: 'accessories',
    nameKey: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-gift-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20wristwatches%20sunglasses%20and%20small%20fashion%20accessories%20arranged%20on%20a%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20minimal%20flat%20lay%20photography%2C%20premium%20clean%20composition&width=600&height=400&seq=cat-accessories&orientation=landscape',
  },
  {
    id: 'bags',
    nameKey: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-briefcase-line',
    image: 'https://readdy.ai/api/search-image?query=Premium%20leather%20backpack%20and%20handbag%20placed%20on%20a%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimal%20product%20photography%2C%20high%20end%20fashion%20aesthetic%20with%20gentle%20shadows&width=600&height=400&seq=cat-bags&orientation=landscape',
  },
  {
    id: 'belts',
    nameKey: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    image: 'https://readdy.ai/api/search-image?query=Rolled%20leather%20belts%20in%20tan%20and%20brown%20tones%20arranged%20on%20a%20warm%20neutral%20background%2C%20soft%20studio%20lighting%2C%20minimal%20product%20photography%2C%20clean%20organized%20composition&width=600&height=400&seq=cat-belts&orientation=landscape',
  },
  {
    id: 'perfumes',
    nameKey: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20glass%20perfume%20bottles%20with%20minimal%20labels%20on%20a%20warm%20neutral%20studio%20background%2C%20soft%20diffused%20lighting%2C%20minimal%20product%20photography%2C%20refined%20fragrance%20aesthetic&width=600&height=400&seq=cat-perfumes&orientation=landscape',
  },
  {
    id: 'other',
    nameKey: 'other',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    image: 'https://readdy.ai/api/search-image?query=Assorted%20small%20fashion%20accessories%20and%20gadgets%20neatly%20arranged%20on%20a%20warm%20neutral%20studio%20background%2C%20soft%20diffused%20lighting%2C%20minimal%20flat%20lay%20photography%2C%20clean%20organized%20composition&width=600&height=400&seq=cat-other&orientation=landscape',
  },
];